export { default } from "./AudioRecorder";
